import React, { Component } from 'react';
import PropTypes from 'prop-types';
import autobind from 'class-autobind';

import map from 'lodash/map';
import some from 'lodash/some';
import includes from 'lodash/includes';
import startsWith from 'lodash/startsWith';

import TagsInputWithClickHandling from 'zoomforth_component_lib/tags_input_with_click_handling.jsx';
import InputContainer from 'zoomforth_component_lib/input_container.jsx';

import {
  ALL_CSS_WIKI_CLASSNAMES 
} from 'zoomforth_codesbane_viewer/const/css_wiki_classnames.js';

const CSS_CLASSES_BLACKLIST = [
  'vjs-styles-defaults',
  'app-container',
  'is-desktop-layout',
  'subpage-is-multisection',
  'header',
  'header-contents',
  'header-thumbnail',
  'secondary-thumbnail',
  'header-text-box',
  'header-title',
  'header-editor-overlay',
  'in-page-search-opener',
  'zfe-icon',
  'in-page-search-icon',
  'navigation-links',
  'navigation-links-container',
  'nav-link-super-wrapper',
  'action-nav-link',
  'nav-link-wrapper',
  'desktop-menu-item-home',
  'selected',
  'nav-link',
  'section-wrapper',
  'section-type-text',
  'galleria-container',
  'galleria-stage',
  'galleria-thumbnails-container',
  'galleria-arrow',
  'galleria-image-nav-right',
  'galleria-image-nav-left',
  'playlist-wrapper',
  'playlist-wrapper-inner',
  'playlist-info-wrapper',
  'video-player-wrapper',
  'video-player',
  'slick-slider',
  'galleria-images',
  'slick-initialized',
  'slick-list',
  'slick-track',
  'slick-slide',
  'slick-active',
  'section-video-background',
  'outer-tiles-wrapper',
  'text-wrapper',
  'text-section-inner',
  'section-editor-layout-controls',
  'is-not-editing',
  'layout-controls-container',
  'section-title',
  'btn-basic',
  'btn-basic-primary',
  'zf-app-modern-icon',
  'zfam-name-arrow-circle-down',
  'zfam-arrow-circle-down',
  'sep',
  'zfam-name-trash',
  'zfam-trash',
  'add-section-container-top',
  'add-section-container',
  'zfam-name-plus',
  'zfam-plus',
  'add-section-container-bottom',
  'section-editor-overlay',
  'is-not-choosing',
  'overlay-click-target',
  'zf-dropzone',
  'section-type-grid',
  'section-type-presentation',
  'section-type-slideshow',
  'section-type-playlist',
  'section-type-html-package',
  'section-type-iframe-embed',
  'section-type-pdf',
  'tiles',
  'react-grid-layout',
  'tiles-grid',
  'enable-smooth-sliding',
  'react-grid-item',
  'react-draggable',
  'cssTransforms',
  'react-resizable',
  'tile-wrapper',
  'type-photo',
  'tile-padding-wrapper',
  'tile',
  'tile-image-wrapper',
  'tile-image',
  'is-cropped',
  'grid-tile-editor-extra-content',
  'click-to-act',
  'react-resizable-handle',
  'type-text',
  'tile-text',
  'tile-creator-tile',
  'tile-creator-tile-inner',
  'tile-creator-icon',
  'tile-creator-tile-text',
  'is-editing',
  'is-editing-section',
  'drop-here',
  'drop-here-inner',
  'drop-here-icon',
  'drop-here-text',
  'button-style',
  'type-pdf',
  'tile-action-indicator-container',
  'indicator-type-pdf',
  'tile-action-icon-wrapper',
  'tile-caption',
  'type-youtube',
  'video-play-button',
  'video-play-button-icon-wrapper',
  'grid-tile-wrapper',
  'footer',
  'powered-by-zf',
  'custom-footer',
  'footer-container',
  'privacy-container',
  'menu-container',
  'disclaimerbox',
  'copyright-container',
  'copyright',
  'icon-container',
  'icon-facebook-sign',
  'icon-twitter-sign',
  'icon-linkedin-sign',
  'fr-tooltip',
  'pulsar-theme',
  'emphasizer-top',
  'is-editing-section-emphasizer',
  'emphasizer-segment',
  'is-clickable',
  'emphasizer-top-right',
  'emphasizer-right',
  'emphasizer-bottom-right',
  'emphasizer-bottom',
  'emphasizer-bottom-left',
  'emphasizer-left',
  'emphasizer-top-left',
  'playlist-item',
  'selected',
  'video-title-section',
  'video-thumbnail',
  'section-iframe-wrapper',
  'zf-iframe',
  'inline-embed-iframe',
  'presentation-wrapper',
  'presentation-top-bar',
  'presentation-bottom-bar',
  'presentation-left',
  'presentation-right',
  'presentation-name',
  'slide-counter',
  'progress-bar',
  'progress-step',
] + ALL_CSS_WIKI_CLASSNAMES;

const CSS_CLASSES_PREFIX_BLACKLIST = [
  'desktop-menu-item-',
  'content-uuid-',
  'current-content-uuid-',
  'section-id-',
  'uuid-',
  'column-count-',
  'zfe-name-',
  'zfe-icon-',
  'zfam-',
  'zf--'
];

const VALID_CLASSNAME_REGEX = /^[a-zA-Z\d\-_]+$/;

const validateTag = (tag, stylePresets)=> {
  if (includes(CSS_CLASSES_BLACKLIST, tag)) {
    return false;

  } else if (includes(map(stylePresets, 'className'), tag)) {
    return false;

  } else if (some(map(CSS_CLASSES_PREFIX_BLACKLIST, (prefix)=> startsWith(tag, prefix)))) {
    return false;

  } else if (!tag.match(VALID_CLASSNAME_REGEX)) {
    return false;

  } else {
    return true;

  }
};

class CssClassesTagsInput extends Component {

  constructor() {
    super();

    this.state = {
      errorMsg: '',
      inputValue: ''
    };

    autobind(this);
  }

  render() {
    const {
      inputValue,
      errorMsg
    } = this.state;

    const {
      tooltip,
      cssClassesList,
      stylePresets,
      shouldIncludeName,
      onCssClassesListChange
    } = this.props;

    return (
      <InputContainer
        dark
        name={shouldIncludeName ? 'CSS classes' : null}
        className="css-classes-tagsinput"
        tooltip={shouldIncludeName ? tooltip : null}
        descriptionText={shouldIncludeName ? null : tooltip}
        error={errorMsg}
      >
        <TagsInputWithClickHandling
          dark
          value={cssClassesList}
          className="react-tagsinput css-classes-input"
          placeholder="CSS class names" 
          inputValue={inputValue}
          validate={(tag)=> {
            return validateTag(tag, stylePresets);
          }}
          onValidationReject={(rejectedTags)=> {
            const pluralWording = (
              rejectedTags.length > 1 ?
                'are invalid class names'
              :
                'is an invalid class name'
            );

            this.setState({
              errorMsg: `
                ${rejectedTags.join(', ')} ${pluralWording}. Class names must
                be alphanumeric with "-" or "_", must not be used in the
                Zoomforth application, and must not be a style preset class name.
              `
            });
          }}
          onChangeInput={(val)=> {
            this.setState({
              errorMsg: '',
              inputValue: val.replace('.', '')
            });
          }}
          onChange={onCssClassesListChange}
        />
      </InputContainer>
    );
  }
}

CssClassesTagsInput.defaultProps = {
  cssClassesList: [],
  shouldIncludeName: false
};

CssClassesTagsInput.propTypes = {
  stylePresets: PropTypes.array.isRequired,
  cssClassesList: PropTypes.array,
  shouldIncludeName: PropTypes.bool,
  onCssClassesListChange: PropTypes.func.isRequired
};

export default CssClassesTagsInput;
